var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoubleArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.28955 11.8894C2.08126 12.0978 2.08126 12.4355 2.28955 12.6438C2.49782 12.852 2.83551 12.852 3.04379 12.6438L7.31045 8.37707C7.51874 8.1688 7.51874 7.83111 7.31045 7.62283L3.04379 3.35617C2.83551 3.14788 2.49782 3.14788 2.28955 3.35617C2.08126 3.56444 2.08126 3.90213 2.28955 4.11041L6.17908 7.99995L2.28955 11.8894ZM8.68955 11.8894C8.48126 12.0978 8.48126 12.4355 8.68955 12.6438C8.89782 12.852 9.23551 12.852 9.44379 12.6438L13.7105 8.37707C13.9187 8.1688 13.9187 7.83111 13.7105 7.62283L9.44379 3.35617C9.23551 3.14788 8.89782 3.14788 8.68955 3.35617C8.48126 3.56444 8.48126 3.90213 8.68955 4.11041L12.5791 7.99995L8.68955 11.8894Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrowRight);
export default __webpack_public_path__ + "static/media/double-arrow-right.d0a7c856a437e7268e1dcd90f901a178.svg";
export { ForwardRef as ReactComponent };